import { mainAxios as axios } from './axios'

export const extractGSearch = async (data) => {
  return axios.post(`/targeting/google/extract-maps-search`, data)
}